// store.js
import { createStore } from "redux";

// Example reducer to manage the data
const initialState = {
  brokerBasicInfo: {},
  brokerDetailedInfo: {},
  userInfo: {},
  p2pbuySellDetails: {},
  btncolor: "#284ccf",
  allColors: {},
  isSidebarOpen: false,
  isTestMode: localStorage.getItem("bill_bitcoins_is_test_mode") === "true",
};

function rootReducer(state = initialState, action) {
  console.log("action", action);
  const theme = localStorage.getItem("theme");

  switch (action.type) {
    case "SET_TEST_MODE":
      return {
        ...state,
        isTestMode: action.payload,
      };
    case "SET_BROKER_BASIC_INFO":
      return {
        ...state,
        brokerBasicInfo: action.payload,
      };

    case "SET_BROKER_DETAILED_INFO":
      return {
        ...state,
        brokerDetailedInfo: action.payload,
      };

    case "SET_USER_INFO":
      return {
        ...state,
        userInfo: action.payload,
      };
    case "ALL_BROKER_MARKETS":
      return {
        ...state,
        brokerMarkets: action.payload,
      };

    case "SET_USER_PROFILE_IMAGE":
      return {
        ...state,
        userProfileImage: action.payload,
      };
    case "SET_P2P_BuySellDetails":
      return {
        ...state,
        p2pbuySellDetails: action.payload,
      };
    case "ALL_COLORS":
      return {
        ...state,
        allColors: action.payload,
        btncolor:
          (theme === "dark"
            ? action.payload.internalButtonColor
            : action.payload.lightInternalButtonColor) || state.btncolor,
      };

    case "TOGGLE_SIDEBAR":
      return {
        ...state,
        isSidebarOpen: action.payload !== undefined ? action.payload : !state.isSidebarOpen,
      };

    case "CLOSE_SIDEBAR":
      return {
        ...state,
        isSidebarOpen: false,
      };

    default:
      return state;
  }
}

const store = createStore(rootReducer);

export default store;
